/**
 * @description
 * Swiper组件配置
 */

import { SwiperOptions } from "swiper"

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => {
  const swiperOptions: SwiperOptions = {
    autoplay: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  }

  return {
    swiperOptions
  }
}
